module.exports = __webpack_public_path__ + "static/media/circular-spinner.473f34f7.svg";